import createReactClass from 'create-react-class';

import AlertIcon from 'components/lib/icons/alert_icon';
import ChatIconOutline from 'components/lib/icons/chat_icon_outline';
import classnames from 'classnames';
import ConversationItemType from 'models/conversation_item_type';
import { CustomerActivityType } from 'models/customer_activity';
import IconClasses from 'components/lib/icon_classes';
import PropTypes from 'prop-types';
import React from 'react';
import SurveyIcon from 'components/lib/icons/survey_icon';
import TicketIcon from 'components/lib/icons/ticket_icon';
import TireWarningIcon from 'components/lib/icons/tire_warning_icon';

const ConversationIcon = createReactClass({
  propTypes: {
    className: PropTypes.string,
    convoBackground: PropTypes.bool,
    filled: PropTypes.bool,
    iconClassName: PropTypes.string,
    isLarge: PropTypes.bool,
    subType: PropTypes.string,
    type: PropTypes.string.isRequired,
  },

  render() {
    const className = classnames({
      'profileAvatar-iconWrapper': !this.props.isLarge,
      'profileAvatar-iconWrapper-large': this.props.isLarge,
      'profileAvatar-iconWrapper-convoBackground': this.props.convoBackground,
    });
    return <div className={className}>{this.renderIcon()}</div>;
  },
  renderIcon() {
    if (
      this.props.type === ConversationItemType.CHAT_MESSAGE ||
      this.props.type === ConversationItemType.CHAT_SELF_SERVICE_METADATA
    ) {
      return (
        <div className="conversationIcon-chat-wrapper">
          <ChatIconOutline className="conversationIcon-chat" />
        </div>
      );
    } else if (
      this.props.type === ConversationItemType.CUSTOMER_ACTIVITY &&
      this.props.subType === CustomerActivityType.ISSUE
    ) {
      return (
        <div className="conversationIcon-ticket-wrapper">
          <TicketIcon className="conversationIcon-ticket" />
        </div>
      );
    } else if (
      this.props.type === ConversationItemType.CUSTOMER_ACTIVITY &&
      this.props.subType === CustomerActivityType.SURVEY
    ) {
      return (
        <div className="conversationIcon-survey-wrapper">
          <SurveyIcon className="conversationIcon-survey" />
        </div>
      );
    } else if (
      this.props.type === ConversationItemType.CUSTOMER_ACTIVITY &&
      this.props.subType === CustomerActivityType.WARNING
    ) {
      return (
        <div className="conversationIcon-warning-wrapper">
          <TireWarningIcon className="conversationIcon-warning" />
        </div>
      );
    } else if (
      this.props.type === ConversationItemType.CUSTOMER_ACTIVITY &&
      this.props.subType === CustomerActivityType.ALERT
    ) {
      return (
        <div className="conversationIcon-alert-wrapper">
          <AlertIcon className="conversationIcon-alert" />
        </div>
      );
    }
    let classList = `conversationIcon ${this.iconClass()}`;
    if (this.props.className) {
      classList += ` ${this.props.className}`;
    }
    return <i className={classList} />;
  },

  iconClass() {
    const type = this.props.type === ConversationItemType.CUSTOMER_ACTIVITY ? this.props.subType : this.props.type;
    if (!(type in IconClasses)) {
      throw new Error(`no icon css class defined for [${type}]`);
    }
    let classes = `${IconClasses[type]}${this.props.filled ? '-filled' : ''}`;
    if (this.props.iconClassName) {
      classes += ` ${this.props.iconClassName}`;
    }
    return classes;
  },
});

export default ConversationIcon;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/conversation_icon.jsx